export enum DeviceNameType {
	ANDROID = 'ANDROID',
	IPHONE = 'IPHONE',
	WINDOWS = 'WINDOWS',
	OTHER = 'OTHER',
}

export const getDevice = () => {
	const agent = navigator.userAgent;
	if (/Android/i.test(agent)) {
		return DeviceNameType.ANDROID;
	}

	if (/iPhone/i.test(agent) || /iPad/i.test(agent) || /iPod/i.test(agent)) {
		return DeviceNameType.IPHONE;
	}

	if (/Windows Phone/i.test(agent)) {
		return DeviceNameType.WINDOWS;
	}

	return DeviceNameType.OTHER;
};
